/*
 * PACKAGES
 */
export const _initialState = {
  'customerId': null,
  'companyName': null,
  'currency': null
}


/*
 * OBJECTS
 */
const _ActiveCustomerReducer = (__prevState = _initialState, __action) => {
  switch (__action.type) {
    case 'ACTIVE_CUSTOMER_SET':
      return { ...__action.ActiveCustomer }
    case 'ACTIVE_CUSTOMER_CLEAR':
      return { ..._initialState }
    default:
      return __prevState || _initialState
  }
}


/*
 * EXPORTS
 */
export default _ActiveCustomerReducer
